import { CalendarDate } from './calendar/index.js';
import { SchemaFactory } from 'fluid-framework';
import { TreeReference } from './TreeReference.js';
const schemaFactory = new SchemaFactory('datapad.character');
export class Relationship extends schemaFactory.object('relationship', {
    kind: schemaFactory.string,
    character: TreeReference,
}) {
}
export class Species extends schemaFactory.object('species', {
    name: schemaFactory.string,
    url: schemaFactory.optional(schemaFactory.string),
}) {
}
export class PhysicialAttributes extends schemaFactory.map('physicial-attributes', [
    schemaFactory.string,
    schemaFactory.number,
    schemaFactory.boolean,
]) {
}
export class Character extends schemaFactory.object('character', {
    id: schemaFactory.identifier,
    name: schemaFactory.string,
    shortName: schemaFactory.optional(schemaFactory.string),
    nicknames: schemaFactory.array(schemaFactory.string),
    aliases: schemaFactory.array(schemaFactory.string),
    species: schemaFactory.optional(Species),
    pronouns: schemaFactory.optional(schemaFactory.string),
    homeworld: schemaFactory.optional(schemaFactory.string),
    affiliations: schemaFactory.array(schemaFactory.string),
    status: schemaFactory.optional(schemaFactory.string),
    bio: schemaFactory.optional(schemaFactory.string),
    knownBy: schemaFactory.array(TreeReference),
    famous: schemaFactory.boolean,
    titles: schemaFactory.array(schemaFactory.string),
    physicalAttributes: PhysicialAttributes,
    imageResourceName: schemaFactory.optional(schemaFactory.string),
    dmNotes: schemaFactory.optional(schemaFactory.string),
    relationships: schemaFactory.array(Relationship),
    birthday: schemaFactory.optional(CalendarDate),
}) {
    static createWithDefaults({ id, name, birthday, nicknames, aliases, species, affiliations, knownBy, famous = false, titles, physicalAttributes, relationships, bio, }) {
        return new Character({
            id,
            name,
            birthday,
            nicknames: nicknames ?? [],
            aliases: aliases ?? [],
            species,
            affiliations: affiliations ?? [],
            knownBy: knownBy ?? [],
            famous,
            titles: titles ?? [],
            physicalAttributes: physicalAttributes ?? {},
            relationships: relationships ?? [],
            bio,
        });
    }
}
//# sourceMappingURL=Character.js.map